<template>
  <div class="card border-0 shadow-sm">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <h6 class="mb-0">Recompra de Clientes</h6>
        <input
          v-model="search"
          type="text"
          class="form-control form-control-sm"
          style="max-width: 220px;"
          placeholder="Buscar cliente..."
          @input="onSearch"
        />
      </div>
    </div>
    <div class="card-body">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      </div>
      <div v-else-if="data">
        <div class="row g-3 mb-3">
          <div class="col-6 col-md-3">
            <div class="text-center">
              <p class="text-xs text-secondary mb-0">Total Clientes</p>
              <h5 class="font-weight-bolder mb-0">{{ data.summary.total_clients }}</h5>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-center">
              <p class="text-xs text-secondary mb-0">Clientes Recurrentes</p>
              <h5 class="font-weight-bolder mb-0 text-success">{{ data.summary.repeat_clients_count }}</h5>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-center">
              <p class="text-xs text-secondary mb-0">Una Sola Compra</p>
              <h5 class="font-weight-bolder mb-0 text-warning">{{ data.summary.single_purchase_count }}</h5>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-center">
              <p class="text-xs text-secondary mb-0">Tasa Recompra</p>
              <h5 class="font-weight-bolder mb-0" :class="data.summary.repurchase_rate >= 50 ? 'text-success' : 'text-warning'">
                {{ data.summary.repurchase_rate }}%
              </h5>
            </div>
          </div>
        </div>

        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <button class="nav-link" :class="activeTab === 'top' ? 'active' : ''" @click="changeTab('top')">
              Mejores Clientes ({{ data.summary.total_clients }})
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link" :class="activeTab === 'repeat' ? 'active' : ''" @click="changeTab('repeat')">
              Recurrentes ({{ data.summary.repeat_clients_count }})
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link" :class="activeTab === 'single' ? 'active' : ''" @click="changeTab('single')">
              Sin Recompra ({{ data.summary.single_purchase_count }})
            </button>
          </li>
        </ul>

        <div class="table-responsive">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cliente</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Compras</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total Gastado</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Última Compra</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="client in data.clients" :key="client.cliente_id">
                <td class="text-sm font-weight-bold">{{ client.name }}</td>
                <td class="text-center text-sm">
                  <span class="badge" :class="client.purchases_count > 1 ? 'bg-success' : 'bg-warning'">
                    {{ client.purchases_count }}
                  </span>
                </td>
                <td class="text-center text-sm text-success font-weight-bold">{{ formatMoney(client.total_spent) }}</td>
                <td class="text-center text-sm">{{ formatDate(client.last_purchase) }}</td>
              </tr>
              <tr v-if="data.clients.length === 0">
                <td colspan="4" class="text-center text-sm text-secondary py-3">No hay datos</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex align-items-center justify-content-between pt-2" v-if="data.pagination">
          <span class="text-xs text-secondary">
            {{ data.pagination.total }} registros · página {{ data.pagination.page }} de {{ data.pagination.last_page }}
          </span>
          <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary mb-0" :disabled="data.pagination.page <= 1" @click="changePage(data.pagination.page - 1)">Anterior</button>
            <button class="btn btn-outline-primary mb-0" :disabled="data.pagination.page >= data.pagination.last_page" @click="changePage(data.pagination.page + 1)">Siguiente</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerRepurchase',
  data() {
    return {
      loading: false,
      data: null,
      activeTab: 'top',
      search: '',
      page: 1,
      searchTimer: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('metrics/getCustomerRepurchase', {
          type: this.activeTab,
          search: this.search,
          page: this.page,
        });
        this.data = response.data;
      } catch (error) {
        console.error('Error loading customer repurchase:', error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.loadData();
      }, 400);
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.page = 1;
      this.loadData();
    },
    changePage(page) {
      this.page = page;
      this.loadData();
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    formatDate(value) {
      if (!value) return '—';
      return new Date(value).toLocaleDateString('es-CO');
    },
  },
};
</script>
